import { render, staticRenderFns } from "./BaseMitChartPie.vue?vue&type=template&id=161bb534&scoped=true"
import script from "./BaseMitChartPie.vue?vue&type=script&lang=js"
export * from "./BaseMitChartPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161bb534",
  null
  
)

export default component.exports